import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppSettings } from '../helpers';

@Injectable()
export class MasterDataService {
    constructor(private http: HttpClient,
        private appSettings: AppSettings) { }

    getMarketingSources() {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/masterData/get-marketing-sources');
    }

    getEducationLevels() {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/masterData/get-education-levels');
    }
}



// WEBPACK FOOTER //
// ./src/services/master.data.service.ts